import { UploadFile } from "components/Upload/UploadFile";
import { FilteringCombobox } from "components/controls/FilteringCombobox";
import InputField from "components/controls/InputField";
import { TextareaField } from "components/controls/TextareaField";
import { Grid } from "components/styled";
import { useFormikContext } from "formik";
import { helpAnchor } from "help/anchor";
import { useRoleType } from "hooks/useRoleType";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";
import { ETaxonomy } from "library/types";
import { useTranslation } from "react-i18next";

export function ClientFormItems() {
  const { t } = useTranslation();
  const { values, setFieldValue, errors } = useFormikContext<FormData>();

  const sicCodeOptions = useTaxonomyOptions(ETaxonomy.SicCode, true);

  const isReadOnlyUser = useRoleType()?.hasReadOnlyRole;

  return (
    <>
      <Grid $gridColumns={2}>
        <InputField
          data-help="edit-client-dialog-name"
          label={t("hbh.clientName.label")}
          name="clientName"
          value={values["clientName"]}
          setFieldValue={setFieldValue}
          error={errors["clientName"]}
          disabled
        />
        <FilteringCombobox
          data-help="edit-client-dialog-sic-code"
          error={errors["sicCode"]}
          setFieldValue={setFieldValue}
          value={values["sicCode"]}
          label={t("hbh.sicCode.label")}
          options={sicCodeOptions}
          name={"sicCode"}
          required
          disabled={isReadOnlyUser}
        />
      </Grid>
      <Grid $gridColumns={3}>
        <UploadFile
          dataHelp={helpAnchor("edit-client-dialog-cover")}
          setFieldValue={setFieldValue}
          fieldName="coverPhoto"
          defaultValue={values["coverPhoto"]}
          label={t("hbh.chooseCompanyCoverPhoto.label")}
          disabled={isReadOnlyUser}
        />
        {/* <UploadFile
          setFieldValue={setFieldValue}
          fieldName="welcomeCoverPhoto"
          defaultValue={values["welcomeCoverPhoto"]}
          label={t("hbh.welcomeCoverPhoto.label")}
          disabled={isReadOnlyUser}
        /> */}
        <UploadFile
          dataHelp={helpAnchor("edit-client-dialog-salary-consent")}
          isDocument
          setFieldValue={setFieldValue}
          fieldName="salaryDeductionConsentDoc"
          defaultValue={values["salaryDeductionConsentDoc"]}
          label={t("hbh.salaryDeductionConsentDoc.label")}
          disabled={isReadOnlyUser}
        />
      </Grid>
      <Grid $gridColumns={1}>
        <TextareaField
          data-help="edit-client-dialog-message"
          required
          label={t("hbh.messageToEmployees.label")}
          name="messageToEmployees"
          value={values["messageToEmployees"]}
          setFieldValue={setFieldValue}
          error={errors["messageToEmployees"]}
          rows={3}
          resize="vertical"
          maxLength={4000}
          disabled={isReadOnlyUser}

          // required
        />
      </Grid>
    </>
  );
}
